import { createConfig } from "@wagmi/core";
import { mainnet } from "@wagmi/core/chains";
import { getDefaultConfig } from "connectkit";
import { PROJECT_ID } from "../resources/constants";

const projectId = PROJECT_ID;

export const config = createConfig(
  getDefaultConfig({
    // Your dApps chains
    chains: [mainnet],
    // transports: {
    //   // RPC URL for each chain
    //   [mainnet.id]: http(
    //     `https://eth-mainnet.g.alchemy.com/v2/${process.env.NEXT_PUBLIC_ALCHEMY_ID}`
    //     // `https://api-dashboard.nautilusassure.io/v1/wallet`
    //   ),
    // },

    // Required API Keys
    walletConnectProjectId: projectId,

    // Required App Info
    appName: "Your App Name",

    // Optional App Info
    appDescription: "Your App Description",
    appUrl: "https://family.co", // your app's url
    appIcon: "https://family.co/logo.png", // your app's icon, no bigger than 1024x1024px (max. 1MB)
  })
);
